export default function Preloader({
  logoText = "Online School",
  message = "Загружаем платформу обучения…",
}) {
  return (
    <div className="fixed inset-0 z-[9999] grid place-items-center bg-white text-gray-700">
      <div className="w-[min(92%,28rem)] mx-auto">
        <div className="flex items-center justify-center gap-3">
          {/* логотип-спиннер */}
          <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-[#f15525] to-[#38bff2] shadow-lg ring-1 ring-black/5 overflow-hidden">
            <div className="absolute inset-0 grid place-items-center">
              <div className="w-11 h-11 rounded-full border-4 border-white/20 border-t-white animate-spin" />
            </div>
          </div>
          <div className="text-center">
            <div className="text-sm uppercase tracking-wide text-gray-500">
              {logoText}
            </div>
            <div className="text-xl font-semibold">Загрузка</div>
          </div>
        </div>

        <p className="mt-5 text-center text-sm text-gray-600">{message}</p>

        {/* прогресс-бар */}
        <div className="mt-4 h-2 w-full rounded-full bg-gray-200 overflow-hidden">
          <div className="h-full w-1/3 bg-gradient-to-r from-[#f15525] to-[#38bff2] animate-[shimmer_1.2s_ease-in-out_infinite]" />
        </div>

        {/* скелетон-блоки */}
        <div className="mt-6 grid grid-cols-3 gap-3">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="rounded-xl bg-gray-200/80 h-16 overflow-hidden"
            >
              <div className="h-full w-1/3 bg-gradient-to-r from-[#f15525]/50 to-[#38bff2]/50 animate-[shimmer_1.2s_ease-in-out_infinite]" />
            </div>
          ))}
        </div>

        {/* локальные keyframes */}
        <style>{`
          @keyframes shimmer {
            0%   { transform: translateX(-100%); }
            50%  { transform: translateX(30%); }
            100% { transform: translateX(200%); }
          }
        `}</style>
      </div>
    </div>
  );
}
